/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    this.setupEventListeners();
  }
  onChange(event) {
    if (event.target.type == 'number') {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    }
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    });
  }
  setupEventListeners() {
    let removes = this.container.querySelectorAll('.remove');


    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {

        this.updateQuantity(event.target.dataset.index, '0', event.target.dataset.productId);

        event.preventDefault();
      });
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.termsCheckbox();
  }
  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  displayErrors(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  async updateQuantity(line, quantity, id) {
    this.container.classList.add('cart-disabled');
    if (line) {
      this.container.querySelector(`#CartItem-${line}`).classList.add('loading');
    }

    try {
      //Get current cart to check if any add-on products should be removed
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }

      const cart = await response.json();

      const updates = {
        [id]: quantity
      }

      let hollowProductStatus;

      if (quantity === '0') {

        let wipeAllTheCart = true;

        cart.items.forEach((item) => {
          //If there is a non-add-on item in the cart that isn't the item being removed, don't wipe the cart
          if (!item.properties['_add-on'] && item.key != id) {
            wipeAllTheCart = false;
          }
        })
        if (wipeAllTheCart) {
          cart.items.forEach(item => {
            if (item.key != id) updates[item.key] = '0';
          })
        } else {
          const productBeingRemovedVarId = cart.items.find(item => item.key == id).variant_id;
          const keysOfProductsBeingRemoved = [id];

          //If there is a resizing hollow item attached to the product being removed, add it to the list of items to remove and factor its removal in when calculating whether the free shipping product should be added/removed
          //Deprecated as should be handled by Shopify via nested cart item system, but might as well be kept
          const attachedResizingHollowItemKey = cart.items.find(item => item.properties['_parent-item-variant-id'] == productBeingRemovedVarId)?.key;
          if (attachedResizingHollowItemKey) {
            keysOfProductsBeingRemoved.push(attachedResizingHollowItemKey);
            updates[attachedResizingHollowItemKey] = '0';
          };

          hollowProductStatus = await getFreeShippingHollowProductStatus({ cart: cart, keysOfProductsBeingRemoved: keysOfProductsBeingRemoved });
          // If the hollow product is in cart and should be removed, remove it as part of the cart update
          if (hollowProductStatus.keyForHollowProductInCart && hollowProductStatus.shouldBeInCart === false) updates[hollowProductStatus.keyForHollowProductInCart] = '0';
        }
      }

      const body = JSON.stringify({
        updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:update:start', {
        quantity: quantity
      });

      fetch(`${theme.routes.cart_update_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then(async (state) => {
          const parsedState = JSON.parse(state);

          if (typeof hollowProductStatus !== 'undefined' && !hollowProductStatus.keyForHollowProductInCart && hollowProductStatus.shouldBeInCart === true) {
            // Free shipping product isn't in the cart and should be
            await addFreeShippingHollowProduct();
          }

          if (parsedState.errors) {
            this.displayErrors(line, parsedState.errors);
            this.container.classList.remove('cart-disabled');
            return;
          }

          this.renderContents(parsedState, line);

          this.container.classList.remove('cart-disabled');

          dispatchCustomEvent('line-item:update:end', {
            quantity: quantity,
            cart: parsedState
          });
        });
    } catch (error) {
      console.error('Updating cart:', error);
    }
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartTerms'),
      checkout_button = this.container.querySelector('.button.checkout-button');


    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  renderContents(parsedState, line) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      this.setupEventListeners();
      if (line && this.container.querySelector(`#CartItem-${line}`)) {
        this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
    }));
  }
}
window.addEventListener('load', () => {
  if (typeof Cart !== 'undefined') {
    new Cart();
  }
});